// extracted by mini-css-extract-plugin
export var title = "linklisttitle-module--title--c781e";
export var wrap = "linklisttitle-module--wrap--e75ea";